import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
export function useSiteTraceBoardParams(component) {
    var _a;
    const params = useParams();
    const paramsKey = Object.entries(params)
        .map(([key, value]) => `${key}=${value}`)
        .join(',');
    // use key to re-evaluate when columns are updated
    // since the columns array does not change reference
    const columnsKey = (((_a = component.props) === null || _a === void 0 ? void 0 : _a.columns) || [])
        .map(column => { var _a; return `${column.id}-${(_a = column.filter) === null || _a === void 0 ? void 0 : _a.routeParam}`; })
        .join(',');
    const columns = useMemo(() => {
        var _a;
        return Array.from(((_a = component.props) === null || _a === void 0 ? void 0 : _a.columns) || []);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [columnsKey]);
    // get filter query params
    const boardParams = useMemo(() => {
        var _a;
        const boardParams = {};
        for (const column of columns) {
            const key = (_a = column.filter) === null || _a === void 0 ? void 0 : _a.routeParam;
            const value = key ? params[key] : undefined;
            if (key && typeof value !== 'undefined' && value !== null) {
                boardParams[key] = value;
            }
        }
        return boardParams;
        // sometimes "params" object is updated even though it does not have any values
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [columns, paramsKey]);
    return boardParams;
}
//# sourceMappingURL=useSiteTraceBoardParams.js.map